import type { ButtonSize, ButtonVariant } from './Button';
import { cx } from './cx';

/**
 * The class list every Button look shares (the control, ButtonLook, and a
 * router Link drawn as a Button such as the landing's LinkButton).
 */
export function buttonClasses({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  className,
}: {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  loading?: boolean;
  className?: string;
}) {
  return cx(
    'ee-button',
    `ee-button--${variant}`,
    `ee-button--${size}`,
    fullWidth && 'ee-button--full',
    loading && 'ee-button--loading',
    className,
  );
}
